import { PrincipalUserLite } from './principal-user-lite';
import { OfflineAgreement } from './customer-management/offline-agreement';
import { FileKeyPair } from './file-key';

export interface TermsOfUse {
  business: SystemTerm;
  platform: SystemTerm;
}

export interface SystemTerm {
  id: number;
  type: string; // VENDOR, COMPANY(main system), COMPANY_FORECASTER
  acknowledge: boolean;
  acknowledgeUser: PrincipalUserLite;
  acknowledgeTimestamp: number;
  bypass: boolean;
  bypassUser: PrincipalUserLite;
  bypassTimestamp: number;
  termsOfUseId?: number;
  termsOfUseReleaseDate?: number;
  bypassReason?: string;
  fileName?: string;
  scope?: TermScope;
  offlineAgreementFile?: FileKeyPair;
  offlineAcknowledgedBy?: string;
  dateSigned?: string;
}

export enum TermScope {
  Business = 'BUSINESS',
  Platform = 'PLATFORM',
}

export interface TermsOfUseHistory {
  fileName: string;
  termsOfUseType: string;
  acknowledgedUser: string;
  dateSigned: string;
  fileSystemKey: string;
  scope: string;
  termOfUseId: number;
}

export interface AcceptTerm {
  acceptPlatformTerm?: boolean;
  acceptBusinessTerm?: boolean;
}
